module.exports = __webpack_public_path__ + "img/rectangle.74797950.png";